const o = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M.75 12h22.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 .75v22.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
export {
  o as default
};
